export default __webpack_public_path__ + "static/media/ring.98294766.mp3";